import type { CurrencyCode } from '@klear/constants/currency'
import type { Money } from '@klear/money'

export const PAST_DUE_BUCKET_KEY = 'past_due'

export type DueChartBucket = {
  key: string
  label: string
  amountByCurrency: Partial<Record<CurrencyCode, Money>>
  offerCount: number
}
